import React, { useEffect, useMemo, useState } from 'react';
import config from 'config';
import Logo from './components/logo/Logo';
import { useSelector, useDispatch } from 'react-redux';
import { t } from 'components/translation/Translation';
import { getProfile } from 'util/auth';
import { getUserProfile } from 'redux/user/user-actions';
// Components Logged in
import LanguageProfile from './components/logged-navigation/LanguageProfile';
import LoggedNavigation from './components/logged-navigation/LoggedNavigation';
// Components No Logged
import NologgedLanguageButtons from './components/no-logged-navigation/NologgedLanguageButtons';
import NoLoggedNavigation from './components/no-logged-navigation/NoLoggedNavigation';
// module styles
import styles from './navigation.module.scss';
// Icons
import {
  Calendar16,
  Search16,
  Favorite16,
  UserAvatar20,
  Password20,
  Gift16,
  Badge16,
  Education16,
  Movement16,
} from '@carbon/icons-react';
import { browserHistory } from 'react-router';

const NavigationLayout = ({ openSettings, openResetPassword }) => {
  const auth = useSelector((state) => state.auth);
  const loggedIn = auth && auth.token;
  const dispatch = useDispatch();
  const [fullname, setFullname] = useState(null);

  let profile = useMemo(() => getProfile(), []);

  const fetchProfile = async () => {
    const response = await dispatch(getUserProfile(profile?.sub));
    const data = response.json;
    let _fullName = `${data?.first_name} ${data?.last_name}` || profile.email;
    setFullname(data?.first_name ? _fullName : profile.email);
  };

  useEffect(() => {
    if (profile?.sub) fetchProfile();
  }, []);

  const routesLogged = [
    { displayName: t('parent:layout.explore'), to: '/scholaMatch', icon: <Search16 /> },
    { displayName: t('parent:layout.track'), to: '/parent-portal/track', icon: <Education16 /> },
    { displayName: t('parent:layout.favorites'), to: '/parent-portal/favorites', icon: <Favorite16 /> },
    // { displayName: t('parent:layout.match'), to: null, icon: <Badge16 /> },
  ];

  const routesNotLogged = [
    { displayName: t('parent:layout.explore'), to: '/scholaMatch', icon: null },
    { displayName: 'Blog', to: '/blog', icon: null },
    { displayName: t('aboutUs:aboutUs'), to: '/about-us', icon: null },
    { displayName: t('parent:layout.areYouSchool'), to: `${config.adminHost}/`, icon: null, external: true },
  ];

  const routesProfileMenu = [
    { displayName: t('parent:layout.profile'), to: null, icon: <UserAvatar20 /> },
    { displayName: t('parent:layout.password_reset'), to: null, icon: <Password20 /> },
    { displayName: t('parent:layout.explore'), to: '/scholaMatch', icon: <Search16 /> },
    // { displayName: t('parent:layout.match'), to: null, icon: <Badge16 /> },
    { displayName: t('parent:layout.track'), to: '/parent-portal/track', icon: <Education16 /> },
    { displayName: t('parent:layout.tours'), to: '/parent-portal/tours', icon: <Movement16 /> },
    { displayName: t('parent:layout.favorites'), to: '/parent-portal/favorites', icon: <Favorite16 /> },
    { displayName: t('parent:layout.referrals'), to: '/parent-portal/referrals', icon: <Gift16 /> },

    { displayName: 'Blog', to: '/blog', icon: null },
    { displayName: t('parent:layout.schola'), to: '/', icon: null },
    { displayName: t('parent:layout.logOut'), to: '/logout', icon: null },
    // { displayName: 'About Schola®', to: '/', icon: null },
  ];

  const { pathname } = browserHistory.getCurrentLocation();
  const isSchoolResultsPage = pathname === '/schola-match' || pathname === '/schola-match-b';

  return (
    <header className={`${styles.header} ${isSchoolResultsPage ? styles.school_results : ''}`}>
      <Logo />
      {loggedIn ? (
        <>
          <LoggedNavigation
            routesNav={routesLogged}
            routesProfileMenu={routesProfileMenu}
            openSettings={openSettings}
            openResetPassword={openResetPassword}
            fullname={fullname}
          />
          <LanguageProfile
            routesProfileMenu={routesProfileMenu}
            openSettings={openSettings}
            openResetPassword={openResetPassword}
            fullname={fullname}
          />
        </>
      ) : (
        <>
          <NoLoggedNavigation routesNav={routesNotLogged} />
          <NologgedLanguageButtons routesNav={routesNotLogged} isLangAvailable={pathname !== '/schola-match'} />
        </>
      )}
    </header>
  );
};

export default NavigationLayout;
